module.exports = __webpack_public_path__ + "img/home_slider_banner.4a056a51.png";